/**
 * 该文件精听和跟读都会引用，修改需考虑到兼容性问题
 */

import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    overflowY: 'auto',
  },

  loadingBox: {
    flex: 1,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#303A44',
  },

  loading: {
    height: 100,
    width: 100,
    margin: '0 auto',
  },

  text: {
    fontSize: 16,
    marginTop: 20,
    color: '#fff',
    textAlign: 'center',
  },

  errorContainer: {
    background: '#fff',
  },

  errorText: {
    flexDirection: 'row',
    color: '#000000',
  },

  feedback: {
    marginLeft: 4,
    marginRight: 4,
    color: '#385DAE',
    cursor: 'pointer',
  },
});



// WEBPACK FOOTER //
// ./src/components/listen/styles.js